

import checkHours from './functions/checkHours.js';
import formatMoney from './functions/formatMoney.js';
import formatMonth from './functions/formatMonth.js';
import formatTwelveHour from './functions/formatTwelveHour.js';
import formatPhone from './functions/formatPhone.js';


export default {

    checkHours,
    formatMoney,
    formatMonth,
    formatTwelveHour,
    formatPhone,

};